import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { LanguageProvider } from './components/utils/useLanguage';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import MobileBottomNav from './components/layout/MobileBottomNav';
import ToastHost from './components/layout/ToastHost';
import OfflineBanner from './components/utils/OfflineBanner';



export default function Layout({ children, currentPageName }) {
  const location = useLocation();

  // Add schema.org structured data
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.innerHTML = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebApplication",
      "name": "Basel mit Kindern",
      "description": "Discover the best family excursion destinations in Basel - indoor, outdoor, free and in any weather",
      "url": "https://baselmitkindern.ch",
      "applicationCategory": "TravelApplication"
    });
    document.head.appendChild(script);
    return () => { if (script.parentNode) script.parentNode.removeChild(script); };
  }, []);

  // Scroll to top on page change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // Register Service Worker (production only)
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      if (import.meta.env.PROD) {
        navigator.serviceWorker
          .register('/service-worker.js')
          .then((registration) => {
            console.log('Service Worker registered:', registration);
          })
          .catch((error) => {
            console.log('Service Worker registration failed:', error);
          });
      } else {
        // In dev: unregister any stale service workers to prevent caching issues
        navigator.serviceWorker.getRegistrations().then((registrations) => {
          registrations.forEach((r) => r.unregister());
        });
      }
    }
  }, []);

  // Pages without header/footer
  const minimalPages = [];

  if (minimalPages.includes(currentPageName)) {
    return (
      <LanguageProvider>
        <OfflineBanner />
        <div className="min-h-screen bg-gray-50">
          {children}
        </div>
        <ToastHost position="top-center" />
      </LanguageProvider>
    );
  }

  return (
      <LanguageProvider>
        <OfflineBanner />
        <div className="min-h-screen bg-gray-50 flex flex-col">
          <Header />
          <div className="h-[112px] flex-shrink-0" />
          <main className="flex-1">
            {children}
          </main>
          <Footer />
          <MobileBottomNav />
          <ToastHost position="top-center" />
        </div>
      </LanguageProvider>
  );
}